import React from 'react';
import { AddressContainer } from '../../../../common/address/containers/address.container';



export const TrainerAddressComponent = ({ onInnerFormChange,selectedAddress }: any) => (
          <>

                <AddressContainer
                    
                    onInnerFormChange={onInnerFormChange}
                    selectedAddress={selectedAddress}
                />
  
           
         
             
                
  
              

</>
)
export default TrainerAddressComponent;
